export default function() {
    let animationDuration = 600;
    let menuItemActiveClass = 'sidebar_menu-item--active';

    function animateSubmenuIn(menuItem, subMenu) {
        menuItem.addClass(menuItemActiveClass);

        subMenu.animate({
            opacity: 1,
            height: "show"
        }, animationDuration);
    }

    function animateSubmenuOut(menuItem, subMenu) {
        subMenu.animate({
            opacity: 0,
            height: "hide"
        }, animationDuration, () =>  {
            menuItem.removeClass(menuItemActiveClass);
        });
    }

    let $menuItems = $('.sidebar_menu-item');

    $menuItems.each((index, element) =>  {
        let $menuItem = $(element);
        let $subMenu = $menuItem.find('.sidebar_submenu');

        if ($menuItem.closest('.sidebar_menu').hasClass('sidebar_menu--products') && $menuItem.hasClass(menuItemActiveClass)) {
            let $sidebarMenu = $subMenu.closest('.sidebar_menu');
            const subMenuHeight = Math.ceil($sidebarMenu.height() - 80);
            const menuItemActivePositionTop = $menuItem.find('.sidebar_submenu-item--active').position().top;

            if (menuItemActivePositionTop >= subMenuHeight) {
                $sidebarMenu.scrollTop((subMenuHeight / 2) + (menuItemActivePositionTop - subMenuHeight));
            }
        }

        if ($subMenu.length) {
            $menuItem.find('> a').click(event =>  {
                event.preventDefault();

                if ($menuItem.hasClass(menuItemActiveClass)) {
                    animateSubmenuOut($menuItem, $subMenu);
                    return;
                }

                let otherActiveMenuItems = $(`.${menuItemActiveClass}`);

                if (otherActiveMenuItems.length && otherActiveMenuItems.find('.sidebar_submenu').length) {
                    otherActiveMenuItems.find('.sidebar_submenu').animate({
                        opacity: 0,
                        height: "toggle"
                    }, animationDuration, () =>  {
                        $('.sidebar_menu-item').removeClass(menuItemActiveClass);
                        animateSubmenuIn($menuItem, $subMenu);
                    });
                } else {
                    animateSubmenuIn($menuItem, $subMenu);
                }
            });
        }
    });

    $('.sidebar_menu-close').click(event => {
        $('.sidebar').toggleClass('is-visible');
    });
}